var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4571_5037)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54417 43.3149L0 38.5601V11.7235L5.54417 6.96875H36.671L42.2151 11.7235V38.5601L36.671 43.3149H5.54417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54417 38.3675L0 33.5914V6.77617L5.54417 2H36.671L42.2151 6.77617V33.5914L36.671 38.3675H5.54417Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54417 40.8341L0 37.8823V21.2214L5.54417 18.2695H36.671L42.2151 21.2214V37.8823L36.671 40.8341H5.54417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.54417 39.3044L0 36.3393V19.6917L5.54417 16.7266H36.671L42.2151 19.6917V36.3393L36.671 39.3044H5.54417Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.7549 43H6.24503C4.20118 40.9562 3.04384 39.7988 1 37.7549V7.24506C3.04384 5.20121 4.20118 4.04384 6.24503 2H36.7549C38.7988 4.04384 39.9562 5.20121 42 7.24506V37.7549C39.9562 39.7988 38.7988 40.9562 36.7549 43Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.876 3.7954L37.3677 5.22361L40.3014 8.03243V36.3348L37.3677 39.1436L35.876 40.5718H6.3155L3.77962 38.1438L1.91499 36.3586V8.05623L3.77962 6.27097L6.3155 3.84302H35.876M36.4976 2.36719H5.69396C3.63044 4.34288 2.46196 5.46165 0.398438 7.43734V36.9299C2.46196 38.9056 3.63044 40.0243 5.69396 42H36.4976C38.5611 40.0243 39.7296 38.9056 41.7931 36.9299V7.43734C39.7296 5.46165 38.5611 4.34288 36.4976 2.36719Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.1982 3.05887L37.8378 4.65947L40.9405 7.68828V37.3117L37.8378 40.3406L36.1982 41.9412H5.85224L3.48106 39.6264L1.10989 37.3117V7.68828L3.48106 5.37359L5.85224 3.05887H36.1982ZM36.627 2H5.37295C3.27926 4.04384 2.09369 5.20121 0 7.24506V37.755C2.09369 39.7988 3.27926 40.9562 5.37295 43H36.627C38.7207 40.9562 39.9063 39.7988 42 37.755V7.24506C39.9063 5.20121 38.7207 4.04384 36.627 2Z",
    fill: "#212121"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.08 18.103V17.143H27.24V16.183H31.08V7.54297H10.92V16.183H14.76V17.143H10.92V18.103H9.96V20.983H9V24.823H9.96V25.783H10.92V37.3031H31.08V25.783H32.04V24.823H33V20.983H32.04V18.103H31.08ZM14.76 15.223H30.12H11.88H14.76ZM15.72 16.183H16.68V17.143H15.72V16.183ZM17.64 16.183H24.36V17.143H17.64V16.183ZM25.32 16.183H26.28V17.143H25.32V16.183ZM12.84 24.823L9.96 24.823V20.983L10.92 20.983V18.103H13.8V20.983H12.84V24.823ZM31.08 18.103V20.983H32.04V24.823H29.16V20.983H28.2V18.103H31.08ZM13.8 20.983H14.76V18.103H16.68V24.823H13.8V20.983ZM17.64 18.103H20.52V24.823H17.64V18.103ZM21.48 18.103H24.36V24.823H21.48V18.103ZM25.32 18.103H27.24V20.983H28.2L28.2 24.823H25.32V18.103ZM15.72 25.7831H18.6V27.7031H15.72V25.7831ZM19.56 25.7831H22.44V27.7031H19.56V25.7831ZM23.4 25.7831H26.28V27.7031H23.4V25.7831ZM15.72 28.6631H17.64V30.5826H15.72V28.6631ZM18.6 28.6631H20.52V30.5826H18.6V28.6631ZM21.48 28.6631H23.4V30.5826H21.48V28.6631ZM24.36 28.6631H26.28V30.5826H24.36V28.6631ZM18.6 36.3431H16.68V31.5431H17.64V30.5826H18.6L18.6 31.5431H20.52L20.52 30.5826H21.48V31.5431H23.4V30.5826H24.36L24.36 31.5431H25.32V36.3431H23.4V32.5031H18.6V36.3431ZM11.88 25.7831H14.76V30.5826H15.72V36.3431H11.88V25.7831ZM19.56 33.4631H22.44V36.3431H19.56V33.4631ZM26.28 30.5826H27.24V25.783H30.12V36.3431H26.28L26.28 30.5826Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2412 30.5808H26.2812V36.3413H30.1213V25.7812H27.2412V30.5808Z",
    fill: "#CE986E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8828 36.3413H15.7228V30.5808H14.7628V25.7812H11.8828V36.3413Z",
    fill: "#CE986E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6397 31.5425H16.6797V36.3425H18.5997V32.5025H23.3997V36.3425H25.3197V31.5425H24.3597V30.582H23.3997V31.5425H21.4797V30.582H20.5197V31.5425H18.5997V30.582H17.6397V31.5425Z",
    fill: "#758397"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9209 20.9816H9.96094V24.8216H12.8409V20.9816H13.8009V18.1016H10.9209V20.9816Z",
    fill: "#E6B389"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0831 18.1016H28.2031V20.9816H29.1631V24.8216H32.0431V20.9816H31.0831V18.1016Z",
    fill: "#F05A6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5206 18.1016H17.6406V24.8216H20.5206V18.1016Z",
    fill: "#E6B389"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3566 18.1016H21.4766V24.8216H24.3566V18.1016Z",
    fill: "#F05A6C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3203 24.8216H28.2003V20.9816H27.2403V18.1016H25.3203V24.8216Z",
    fill: "#E6B389"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7569 20.9816H13.7969V24.8216H16.6769V18.1016H14.7569V20.9816Z",
    fill: "#F05A6C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4425 33.4648H19.5625V36.3449H22.4425V33.4648Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2784 25.7812H23.3984V27.7013H26.2784V25.7812Z",
    fill: "#CE986E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4425 25.7812H19.5625V27.7013H22.4425V25.7812Z",
    fill: "#CE986E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5987 25.7812H15.7188V27.7013H18.5987V25.7812Z",
    fill: "#CE986E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2794 28.6641H24.3594V30.5836H26.2794V28.6641Z",
    fill: "#A3B0C3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6387 28.6641H15.7188V30.5836H17.6387V28.6641Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3966 28.6641H21.4766V30.5836H23.3966V28.6641Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5216 28.6641H18.6016V30.5836H20.5216V28.6641Z",
    fill: "#A3B0C3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2803 16.1836H25.3203V17.1436H26.2803V16.1836Z",
    fill: "#758397"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6787 16.1836H15.7188V17.1436H16.6787V16.1836Z",
    fill: "#758397"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1581 13.1577H14.786V10.5534H15.1581V10.9254H15.3441V11.1115H15.5301V11.2975H15.9022V11.1115H16.0882V10.9254H16.2742V10.5534H16.6463V13.1577H16.2742V11.4835H16.0882V11.6695H15.9022V12.0416H15.5301V11.6695H15.3441V11.4835H15.1581V13.1577ZM17.3904 12.0416H18.5065V11.4835H18.3205V11.2975H18.1345V11.1115H17.7624V11.2975H17.5764V11.4835H17.3904V12.0416ZM17.3904 13.1577H17.0183V11.2975H17.2043V11.1115H17.3904V10.9254H17.5764V10.7394H17.7624V10.5534H18.1345V10.7394H18.3205V10.9254H18.5065V11.1115H18.6925V11.2975H18.8786V13.1577H18.5065V12.4136H17.3904V13.1577ZM19.6227 10.9254V11.6695H20.5528V11.4835H20.7388V11.1115H20.5528V10.9254H19.6227ZM19.8087 12.0416H19.6227V13.1577H19.2506V10.5534H20.7388V10.7394H20.9248V10.9254H21.1109V11.6695H20.9248V11.8556H20.7388V12.0416H20.3668V12.2276H20.5528V12.4136H20.7388V12.5997H20.9248V12.7857H21.1109V13.1577H20.7388V12.9717H20.5528V12.7857H20.3668V12.5997H20.1807V12.4136H19.9947V12.2276H19.8087V12.0416ZM21.8549 12.0416V13.1577H21.4829V10.5534H21.8549V11.6695H22.041V11.4835H22.227V11.2975H22.413V11.1115H22.599V10.9254H22.7851V10.7394H22.9711V10.5534H23.3431V10.9254H23.1571V11.1115H22.9711V11.2975H22.7851V11.4835H22.599V11.6695H22.413V12.0416H22.599V12.2276H22.7851V12.4136H22.9711V12.5997H23.1571V12.7857H23.3431V13.1577H22.9711V12.9717H22.7851V12.7857H22.599V12.5997H22.413V12.4136H22.227V12.2276H22.041V12.0416H21.8549ZM25.5754 10.5534V10.9254H24.0872V11.6695H25.2034V12.0416H24.0872V12.7857H25.5754V13.1577H23.7152V10.5534H25.5754ZM26.6916 10.9254H25.9475V10.5534H27.8077V10.9254H27.0636V13.1577H26.6916V10.9254Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4571_5037",
    x: 0,
    y: 0.57233,
    width: 42.2188,
    height: 42.7441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.42767
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4571_5037"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4571_5037",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketPlace);
export default __webpack_public_path__ + "static/media/marketPlace.5fd4dc04c09c00c53c5f61732ae5095f.svg";
export { ForwardRef as ReactComponent };